import _ from 'lodash';
import TabBar from '@mobile/components/TabBar.vue';

export default {
    functional: true,
    render(h, { parent, props }) {
        const { routes } = parent.$router.options;
        return h(TabBar, {
            class: '',
            props: {
                tabs: [
                    {
                        title: parent.$t('Inspections'),
                        route: { name: 'todos' },
                        meta: _.find(routes, (route) => _.eq(route.name, 'todos')).meta,
                    },
                    {
                        title: parent.$t('Issues'),
                        route: { name: 'todos-issues' },
                        meta: _.find(routes, (route) => _.eq(route.name, 'todos-issues')).meta,
                    },
                ],
                isOnFreePlan: props.isOnFreePlan,
            },
        });
    },
};
